import React, {Component} from 'react';
import { connect } from 'react-redux';
import { toastMessage } from '../utils/toast';
import * as formActions from '../../Redux/Actions/form';
import * as userAuthActions from '../../Redux/Actions/user';
import Header from '../Ui/Header';
import DropDown from '../Ui/DropDown';
import {SecondaryButton} from '../Ui/Button';
import Warning from '../Ui/400';
import {ContainerOuter, SelectContainer, SelectContainer2, OptionsContainer} from './styles';

class Dashboard extends Component{

    state = {
        forms: [],
        formID: null,
        userMenu: false,
        errStatus: 200
    };

    componentDidMount(){
        this.getAllForms();
    }

    getAllForms = () => {
        const { history, userAuthLogout } = this.props;
        formActions.getAllForms().then(res => {
            let formsList = [];
            res.data && res.data.map(form => formsList.push({"label": form.name, "value": form.id, ...process}));
            this.setState({
                forms: formsList
            });
        }).catch(err => {
            this.setState({errStatus: err?.response?.status});
            if(err?.response?.status === 401) {
                userAuthLogout();
                localStorage.removeItem('jwt');
                history.push('/');
            }
        });
    }

    handleFormChange = (key, value) => {
        this.setState({
            [key]: value
        });
    }

    handleRedirectForm = (key, formID) => {
        const {history} = this.props;
        formID ? history.push(`/${key}-form/${formID}`) : this.handleErrorState('error', 'Select the form');
    }

    handleErrorState = (type, message) => {
        toastMessage(type, message);
        this.setState({
            loading: false
        });
    }

    handleUserLogout = () => {
        const { history } = this.props; 
        this.setState({userMenu: false});
        localStorage.removeItem('jwt');
        history.push('/');
    }

    render(){
        const { errStatus, forms, formID, userMenu } = this.state;
        const { history } = this.props;

        if(errStatus === 400){
            return <Warning history={history} />;
        }

        return(
            <>
                <ContainerOuter>
                    <Header history={history} updateUserMenu={() => this.setState({userMenu: !userMenu})} userMenu={userMenu} handleUserLogout={this.handleUserLogout} />
                    <SelectContainer>
                        <SelectContainer2>
                            <DropDown placeholder={'Select Form'} options={forms} onChange={value => this.handleFormChange('formID', value.value)} />
                        </SelectContainer2>
                        <OptionsContainer>
                            <SecondaryButton className="m-5" onClick={() => history.push('/create-form')}>Create</SecondaryButton>
                            <SecondaryButton className="m-5" onClick={() => this.handleRedirectForm('edit', formID)}>Edit</SecondaryButton>
                            <SecondaryButton className="m-5" onClick={() => this.handleRedirectForm('preview', formID)}>Preview</SecondaryButton>
                            <SecondaryButton className="m-5" onClick={() => history.push('/form-mapping')}>Mapping</SecondaryButton>
                            <SecondaryButton className="m-5" onClick={() => history.push('/document-vault')}>Document Vault</SecondaryButton>
                        </OptionsContainer>
                    </SelectContainer>
                </ContainerOuter>
            </>
        );
    };
};

const mapStateToProps = ({User}) => ({
    userID: User.data.UserId
});

const mapDispatchToProps = (dispatch) => ({
    userAuthLogout: () => dispatch(userAuthActions.userAuthLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);